import { Capacitor } from '@capacitor/core';
import type { Platform } from './types';
import { webPlatform } from './web';

export * from './types';

/** True inside the Capacitor shell (iOS/Android), false in every browser including the PWA. */
export function isNativeApp(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

let cached: Promise<Platform> | null = null;
let override: Platform | null = null;

/**
 * Selects the implementation at runtime. The Capacitor plugins are only imported inside
 * the native shell, so browsers never download them.
 */
export function getPlatform(): Promise<Platform> {
  if (override) return Promise.resolve(override);
  cached ??= isNativeApp()
    ? import('./native').then((m) => m.nativePlatform)
    : Promise.resolve(webPlatform);
  return cached;
}

/** Test seam. Pass null to restore the automatic selection. */
export function setPlatformForTests(platform: Platform | null): void {
  override = platform;
  cached = null;
}
